import React, { Component } from "react";
import "../Styles/SvgCommand.css";

const CloseCommand = (props) => {
  return (
    <svg className={"svg" + " " + props.className} onClick={props.onClick}>
      <rect x="6" y="0" width="16" height="1.5" rx="1" transform="rotate(45)" />
      <rect
        x="-9"
        y="13"
        width="16"
        height="1.5"
        rx="1"
        transform="rotate(-45)"
      />
    </svg>
  );
};

export default CloseCommand;
